import axios from 'axios'
import { API_URL } from '../config/Config'

export default function EventGroupService() {
  this.deActivateEventGroup = (id, reason) => {
    var url = `${API_URL}/EventManagement/DeleteEventGroup?id=${id}&StatusReason=${reason}`
    return axios.get(url).then((response) => response.data)
  }
  this.getAllEventGroups = () => {
    var url = `${API_URL}/EventManagement/EventGroupIndex`
    return axios.get(url).then((response) => response.data.EventGroups)
  }
  this.updateEventGroup = (data) => {
    var url = `${API_URL}/EventManagement/UpdateEventGroup`
    return axios.post(url, data).then((response) => response.data)
  }
  this.createEventGroup = (data) => {
    let config = {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'DELETE, POST, GET, OPTIONS',
        'Access-Control-Allow-Headers':
          'Content-Type, Authorization, X-Requested-With',
      },
    }
    var url = `${API_URL}/EventManagement/InsertEventGroup`
    return axios.post(url, data).then((response) => response.data)
  }
}
